import { Component, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { ConfigName, ConfigService } from '../@vex/services/config.service';
import { MatIconRegistry } from '@angular/material/icon';
import { Settings } from 'luxon';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import icAssigment from '@iconify/icons-ic/twotone-assignment';
import { LayoutService } from '../@vex/services/layout.service';
import { ActivatedRoute } from '@angular/router';
import { filter, take } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { iconsFA } from 'src/static-data/icons-fa';

import {
  StyleService,
  Style,
  AuthService,
  NavigationService,
  MenuAplicacionStoreService,
  UserLayoutService,
  SplashScreenService,
} from 'dvt-lib';

@Component({
  selector: 'vex-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(private configService: ConfigService,
    private styleService: StyleService,
    private iconRegistry: MatIconRegistry,
    private renderer: Renderer2,
    private platform: Platform,
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string,
    private layoutService: LayoutService,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private menuAppStore: MenuAplicacionStoreService,
    private userLayoutService: UserLayoutService,
    private splashScreenService: SplashScreenService,
    private authService: AuthService,) {

    this.authService.ejecutarSecuenciaInicial();

    this.iconRegistry.setDefaultFontSetClass('iconify');
    Settings.defaultLocale = this.localeId;

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('rtl') && coerceBooleanProperty(queryParamMap.get('rtl')))
    ).subscribe(queryParamMap => {
      this.document.body.dir = 'rtl';
      this.configService.updateConfig({
        rtl: true
      });
    });

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('layout'))
    ).subscribe(queryParamMap => this.configService.setConfig(queryParamMap.get('layout') as ConfigName));

    this.route.queryParamMap.pipe(
      filter(queryParamMap => queryParamMap.has('style'))
    ).subscribe(queryParamMap => this.styleService.setStyle(queryParamMap.get('style') as Style));

    /*
    this.navigationService.items = [
      {
        type: 'dropdown',
        label: 'Gestión de esfuerzos',
        icon: iconsFA.clock,
        children: [
          {
            type: 'link',
            label: 'Registro horas de esfuerzo',
            route: '/dashboard'
          }
          ,
          {
            type: 'link',
            label: 'Informe de esfuerzos',
            route: '/reporte'
          }
        ]
      },
      {
        type: 'dropdown',
        label: 'Parametrización',
        icon: iconsFA.tools,
        children: [
          {
            type: 'link',
            label: 'Proyectos',
            route: '/proyectos'
          },
          {
            type: 'link',
            label: 'Empresas',
            route: '/empresas'
          }
        ]
      }
    ];
    */
    this.configuracionInicia();
  }

  private configuracionInicia() {
    // cuando esté listo el usuario se cargan menus y se fija el usuario para el layout
    this.authService.usuario$.subscribe((u) => {
      this.menuAppStore.cargarMenusAplicacion();
      this.userLayoutService.fijarUsuario(u);
    });
    // Una vez los datos de menús se carguen se construye el menú ui con ellos
    this.menuAppStore.menuAplicacion$.subscribe((menus) =>
      this.navigationService.inicializarMenus(menus),
    );
    // si se emite una acción de logout se llama al servicio de autenticación
    this.userLayoutService.logout$.pipe(take(1)).subscribe(() => this.authService.logout());
    this.styleService.setStyle(Style.light);
  }
}
